module.exports = __webpack_public_path__ + "img/chart_inactive_24dp@2x.3e76fdeb.png";